import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";

import { Icon } from "../../../Icon/Icon";
import { AllIconName } from "../../../Icon/types";

export enum IconOptionTestIds {
  Component = "icon-option",
}

type ContainerProps = {
  $isFirst?: boolean;
  $isLast?: boolean;
  $disabled?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  cursor: pointer;
  ${({ $isFirst }): FlattenSimpleInterpolation =>
    $isFirst
      ? css`
          border-top-left-radius: var(--size-border-radius-small);
          border-top-right-radius: var(--size-border-radius-small);
        `
      : css``}
  ${({ $isLast }): FlattenSimpleInterpolation =>
    $isLast
      ? css`
          border-bottom-left-radius: var(--size-border-radius-small);
          border-bottom-right-radius: var(--size-border-radius-small);
        `
      : css``}
  ${({ $disabled }): FlattenSimpleInterpolation =>
    $disabled
      ? css`
          color: var(--color-primary-200);
          cursor: not-allowed;
          svg {
            --main-color: var(--color-primary-200);
          }
        `
      : css`
          &:hover {
            background-color: var(--color-secondary-200);
          }
        `}
`;

type Props = {
  id?: string;
  className?: string;
  testId?: string;
  iconName: AllIconName;
  isFirst?: boolean;
  isLast?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  preventDefault?: boolean;
};

export const IconOption: FC<Props> = ({
  id,
  className,
  testId,
  iconName,
  isFirst,
  isLast,
  disabled,
  onClick,
  preventDefault,
}) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? IconOptionTestIds.Component}
    $isFirst={isFirst}
    $isLast={isLast}
    $disabled={disabled}
    onClick={disabled ? undefined : onClick}
    onMouseDown={(event) => preventDefault && event.preventDefault()}
  >
    <Icon iconName={iconName} iconSize="small" plain />
  </Container>
);
